import type { MailboxInfo } from 'owa-client-types';
import { isAccountExplicitLogon } from './isAccountExplicitLogon';
/**
 * Function to check if the mailboxInfo is the archive of a shared resource
 * This explicitly excludes shared account archives, for that check isAccountExplicitLogon
 */
export function isMailboxSharedResourceArchive(mailboxInfo?: MailboxInfo): boolean {
    return (
        !!mailboxInfo &&
        mailboxInfo.type == 'ArchiveMailbox' &&
        !!mailboxInfo.isExplicitLogon &&
        !!mailboxInfo.explicitLogonMailboxSmtpAddress &&
        !isAccountExplicitLogon(mailboxInfo)
    );
}
